import React from 'react';
import './App.css';

const Support: React.FC = () => {
  return (
    <div className="App mobile-container">
      <div className="screen beta-access">
        <div className="beta-content">
          <div className="hero-section">
            <h1 className="hero-title">vibesplit support</h1>
          </div>

          <div className="support-content">
            <div className="support-section">
              <h2 className="support-heading">Contact</h2>
              <p className="support-text">
                For questions, issues, or feedback, email:
              </p>

              <div className="contact-options">
                <div className="contact-item">
                  <div className="contact-label">Email</div>
                  <a href="mailto:zeko@vibesplit.xyz" className="contact-link">
                    zeko@vibesplit.xyz
                  </a>
                </div>

              </div>
            </div>

            <div className="support-footer">
              <a href="/" className="back-link">← Back to Home</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
